





















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import '@/compiled-icons/format-align-center';
import '@/compiled-icons/format-align-left';
import '@/compiled-icons/format-align-right';
import '@/compiled-icons/format-align-justify';
import '@/compiled-icons/toy-brick-plus-outline';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';

import '@/compiled-icons/add';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';

@Component({
  name: 'dynamic-document-checkbox-field-template',
  components: {
    AmetrasHexColorPickerTemplate,
    AmetrasDateFieldTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasTextFieldTemplate,
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentCheckboxFieldTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeCheckboxDtoV2 | undefined;

}
